import Button from '@/components/atoms/button';
import * as ViewModel from '@/core/presenter/viewModel';
import SendTransactionInfo from './SendTransactionInfo';
import SendTransactionAmountInfo from './SendTransactionAmountInfo';

interface IProps {
    trxAddress: string;
    sendAddress: string;
    curculateKrw: string;
    sendAsset: string;
    selectedAsset?: ViewModel.IAsset;
    trxBalance: string;
    fee: number;
    isFeeNotice: boolean;
    onClickSendCheckNextBtn: () => void;
    onClickSendCancelBtn: () => void;
}

const SendCheckViewContent = ({trxAddress, sendAddress, curculateKrw, sendAsset, selectedAsset, trxBalance, fee, onClickSendCheckNextBtn, onClickSendCancelBtn}: IProps ) => {
    return (
        <div className="container-style2">
            <div className="container-confirm">
                <SendTransactionInfo trxAddress={trxAddress} sendAddress={sendAddress} />
                <SendTransactionAmountInfo 
                    sendAsset={sendAsset} 
                    curculateKrw={curculateKrw} 
                    selectedAsset={selectedAsset} 
                    trxBalance={trxBalance} 
                    fee={fee} 
                />
                 {/* 수수료 정책 미정으로 추후 논의 */}
                {/* <FeeCheckBox isFeeNotice={isFeeNotice} /> */}
                <div className="button-area">
                    <Button caption='취소' className='cancel-button fivefive l-button body-n-n' onClick={onClickSendCancelBtn} />
                    <Button caption='확인' className='confirm-button fivefive l-button body-n-n' onClick={onClickSendCheckNextBtn} />
                </div>
            </div>
        </div>
    )
}

export default SendCheckViewContent    